import { computed, observable } from 'mobx';
import { useEffect } from 'react';
import Video from '@src/components/video';
import BaseStore from '@src/utils/store/base-store';
import $$tracker from '@src/tracker';
// import AntdMessage from '@src/components/antd/message';
import { go } from '@src/utils/promise';
import { formatNumber } from '@src/utils/format/num';

class HomeStore extends BaseStore {
  constructor(data) {
    super();
    this.mainStore = data.mainStore;
  }

  @observable reservedNum = [];
  @computed
  get isActive() {
    return this.mainStore.pageChangeStore.currentPage === 'home';
  }

  reservationStageList = [
    {
      numText: '100w人',
      name: '银两*88888',
      url: require('./images/award1.png'),
      num: 1000000
    },
    {
      numText: '300w人',
      name: '元宝*288',
      url: require('./images/award2.png'),
      num: 3000000
    },
    {
      numText: '500w人',
      name: '动作·翩霜',
      url: require('./images/award3.png'),
      num: 5000000
    },
    {
      numText: '800w人',
      name: '梭板·御剑行',
      url: require('./images/award4.png'),
      num: 8000000
    },
    {
      numText: '1000w人',
      name: '动态背饰',
      url: require('./images/award5.png'),
      num: 10000000
    }
  ];

  /** 打开视频弹窗 */
  openVideoPlayModal = () => {
    if (!this.mainStore.omniDataHome?.expansion_pack_video) return;
    this.mainStore.pageChangeStore.isScrollLocked = true;
    Video.append({ src: this.mainStore.omniDataHome?.expansion_pack_video }).promise.finally(() => {
      this.mainStore.pageChangeStore.isScrollLocked = false;
    });
  };
  /** 打开预约弹窗 */
  onReservation = () => {
    if (this.mainStore?.projectConfig?.phone) return;
    $$tracker.clickReservation('首页');
    this.mainStore?.openReservationModal();
  };
  getReservedNum = async () => {
    const [res, err] = await go(this.$ztService.getSubscribeCount());
    if (err) {
      // AntdMessage.error(err.message || '获取预约人数失败');
      return;
    }
    this.reservedNum = formatNumber(res?.subscribe_total || 0)
      .toString()
      .split('');
  };
  use() {
    useEffect(() => {
      this.getReservedNum();
    }, []);
  }
}

export default HomeStore;
